import { saveAs } from 'file-saver';

export const exportCanvas = id => {
	const canvas = document.getElementById(id);
	canvas.toBlob(blob => {
		saveAs(blob, 'chart.png');
	});
};
